import type { ProductSoldRollup } from "./api.js";

const names = new Intl.Collator("en-GB", { numeric: true, sensitivity: "base" });

export function compareProducts(a: ProductSoldRollup, b: ProductSoldRollup): number {
  return Number(!a.productFamily) - Number(!b.productFamily)
    || names.compare(a.productFamily ?? "", b.productFamily ?? "")
    || names.compare(a.displayName || a.item, b.displayName || b.item)
    || names.compare(a.sku || a.item, b.sku || b.item);
}

export function formatProductQuantities(product: ProductSoldRollup): string {
  if (!product.uniqueQuantities) return "Regenerate report";
  if (!product.uniqueQuantities.length) return "Not recorded";
  return [...new Set(product.uniqueQuantities)].sort((a, b) => a - b)
    .map(q => q.toLocaleString("en-GB", { maximumFractionDigits: 12 })).join(", ");
}
